<template>
  <div id="app">
    <main-view v-if="isConnected"></main-view>
    <not-connected v-else></not-connected>
  </div>
</template>

<script>
  import Vue from 'vue'
  import Vuex from 'vuex'

  Vue.use(Vuex)

  import VueNativeSock from 'vue-native-websocket'

  var cL = window.location
  if (process.env.URL) {
    console.log( 'Connecting to URL defined in the environment: ' + process.env.URL )
    Vue.use(VueNativeSock, process.env.URL, { store: store })
  } else {
    var prot = 'ws:'
    if(location.protocol === 'https:'){
      prot = 'wss:'
    }
    Vue.use(VueNativeSock, prot + '//' + cL.hostname + ':' + cL.port + '/ws', { store: store })
  }

  import ElementUI from 'element-ui'
  import 'element-ui/lib/theme-chalk/index.css'

  Vue.use(ElementUI)

  import store from './store'
  import NotConnected from './components/not-connected'
  import MainView from './components/main-view'

  export default {
    name: 'app',
    store,
    components: {
      NotConnected,
      MainView
    },
    computed: {
      isConnected() {
        return store.state.connected
      }
    }
  }
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
* {
  margin: 0;
  padding: 0;
  transition: none !important
}
</style>



// WEBPACK FOOTER //
// App.vue?37cf2cef